import React from 'react';
import { BookOpen } from 'lucide-react';
export function WhatYouGet() {
  const epistles = ['Romanos', '1 Corintios', '2 Corintios', 'Gálatas', 'Efesios', 'Filipenses', 'Colosenses', '1 Tesalonicenses', '2 Tesalonicenses', '1 Timoteo', '2 Timoteo', 'Tito', 'Filemón'];
  return <section className="py-12 md:py-16 relative" style={{
    background: '#F6F1E7'
  }} data-id="element-333">
      <div className="gold-divider absolute top-0 inset-x-0" data-id="element-334" />
      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-335">
        <div className="text-center mb-8" data-id="element-336">
          <h2 className="text-2xl md:text-3xl font-serif font-bold mb-2" style={{
          color: '#1C1C1C'
        }} data-id="element-337">
            Las 13 Epístolas Que Estudiarás en Profundidad
          </h2>
          <p className="text-base" style={{
          color: '#6B6B6B'
        }} data-id="element-338">
            Cada una explicada versículo por versículo, con contexto y
            aplicación práctica
          </p>
          <div className="mt-3 mx-auto w-20 gold-divider" data-id="element-339" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-340">
          {epistles.map((epistle, index) => <div key={index} className="flex items-center p-3 rounded-lg" style={{
          background: '#FBF8F2',
          border: '1px solid rgba(200,169,106,0.25)',
          boxShadow: '0 1px 6px rgba(60,40,10,0.05)'
        }} data-id="element-341">
              <div className="flex-shrink-0 p-1.5 rounded mr-3" style={{
            background: 'rgba(200,169,106,0.12)',
            border: '1px solid rgba(200,169,106,0.3)'
          }} data-id="element-342">
                <BookOpen className="w-4 h-4" style={{
              color: '#B89555'
            }} data-id="element-343" />
              </div>
              <span className="font-bold text-sm" style={{
            color: '#1C1C1C'
          }} data-id="element-344">
                {epistle}
              </span>
            </div>)}
        </div>
      </div>
      <div className="gold-divider absolute bottom-0 inset-x-0" data-id="element-345" />
    </section>;
}